import { defineMessages } from '@jutro/locale';

export default defineMessages({
    percentageChange: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalsReportAdditionalFilter.PercentageChange',
        defaultMessage: '% Change:'
    },
    any: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalsReportAdditionalFilter.Any',
        defaultMessage: 'Any'
    },
    fivepercent: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalReportAdditionalFilter.5%',
        defaultMessage: '>5%'
    },
    tenpercent: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalReportAdditionalFilter.10%',
        defaultMessage: '>10%'
    },
    fifteenpercent: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalReportAdditionalFilter.15%',
        defaultMessage: '>15%'
    },
    twentyfivepercent: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalReportAdditionalFilter.25%',
        defaultMessage: '>25%'
    }
});
